import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import ContextMenu from '@/modules/common/components/ContextMenu';

const Component = (props) => {
    const isDisabledEditItem = () => !props.affiliates.length || !props.types.length || !props.statuses.length;

    return (
        <ContextMenu position={props.position} onClose={props.onClose}>
            <MenuItem onClick={props.onClickView}>Просмотреть</MenuItem>
            {(!props.user.affiliate)
                ? <MenuItem onClick={props.onClickEdit} disabled={isDisabledEditItem()}>Изменить</MenuItem>
                : null
            }
            {(!props.user.affiliate) ? <MenuItem onClick={props.onClickDelete}>Удалить</MenuItem> : null}
        </ContextMenu>
    );
};

Component.propTypes = {
    position: PropTypes.object.isRequired,
    onClickView: PropTypes.func.isRequired,
    onClickEdit: PropTypes.func.isRequired,
    onClickDelete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        user: state.auth.user,
        types: state.types,
        statuses: state.statuses,
        affiliates: state.affiliates,
    }),
    null
)(Component);
